var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_14424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_14424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1667 66.8748L73.5417 37.4998L67.7083 31.6665L44.1667 55.2082L32.2917 43.3332L26.4583 49.1665L44.1667 66.8748ZM20.8333 87.4998C18.5417 87.4998 16.5799 86.6839 14.9479 85.0519C13.316 83.42 12.5 81.4582 12.5 79.1665V20.8332C12.5 18.5415 13.316 16.5797 14.9479 14.9478C16.5799 13.3158 18.5417 12.4998 20.8333 12.4998H38.3333C39.2361 9.99984 40.7465 7.98595 42.8646 6.45817C44.9826 4.93039 47.3611 4.1665 50 4.1665C52.6389 4.1665 55.0174 4.93039 57.1354 6.45817C59.2535 7.98595 60.7639 9.99984 61.6667 12.4998H79.1667C81.4583 12.4998 83.4201 13.3158 85.0521 14.9478C86.684 16.5797 87.5 18.5415 87.5 20.8332V79.1665C87.5 81.4582 86.684 83.42 85.0521 85.0519C83.4201 86.6839 81.4583 87.4998 79.1667 87.4998H20.8333ZM20.8333 79.1665H79.1667V20.8332H20.8333V79.1665ZM50 17.7082C50.9028 17.7082 51.6493 17.413 52.2396 16.8228C52.8299 16.2325 53.125 15.4859 53.125 14.5832C53.125 13.6804 52.8299 12.9339 52.2396 12.3436C51.6493 11.7533 50.9028 11.4582 50 11.4582C49.0972 11.4582 48.3507 11.7533 47.7604 12.3436C47.1701 12.9339 46.875 13.6804 46.875 14.5832C46.875 15.4859 47.1701 16.2325 47.7604 16.8228C48.3507 17.413 49.0972 17.7082 50 17.7082Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/Verification.63e4dd3dfd644c6821e602ea2429e655.svg";
export { ForwardRef as ReactComponent };